import {StyleSheet} from 'react-native';

import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  expiryLabel: {
    ...getFontFamily('bold'),
  },
});
